import { useState } from 'react';
import { Outlet } from 'react-router-dom';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useTheme } from '@mui/material/styles';
import { TopBar } from './TopBar';
import { Sidebar } from './Sidebar';
import { ProjectProvider } from '../context/ProjectContext';
import { ScrollToTopButton } from '../components/ScrollToTopButton';
import { AppFooter } from '../components/AppFooter';
import { ChatbotWidget } from '../components/ChatbotWidget/ChatbotWidget';

/**
 * Khung ứng dụng: AppBar cố định + Drawer thu gọn được + vùng nội dung (Outlet).
 * Responsive: desktop/laptop dùng Drawer permanent (thu gọn),
 * tablet/mobile dùng Drawer tạm thời (temporary).
 */
export function AppShell(): JSX.Element {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  // Desktop: mở rộng mặc định. Mobile: đóng mặc định.
  const [open, setOpen] = useState(true);

  const toggleSidebar = () => setOpen((v) => !v);
  const closeSidebar = () => setOpen(false);

  return (
    <ProjectProvider>
      <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: 'background.default' }}>
        <TopBar onToggleSidebar={toggleSidebar} />
        <Sidebar open={open} isMobile={isMobile} onClose={closeSidebar} />
        {/* Cột flex: phần nội dung giãn hết chỗ trống để footer luôn nằm đáy
            màn hình, kể cả ở những trang ngắn. */}
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            width: '100%',
            minWidth: 0,
            minHeight: '100vh',
            display: 'flex',
            flexDirection: 'column',
            p: { xs: 2, sm: 3 },
          }}
        >
          <Toolbar />
          <Box sx={{ flexGrow: 1, minWidth: 0 }}>
            <Outlet />
          </Box>
          <AppFooter />
        </Box>
        <ScrollToTopButton />
        <ChatbotWidget />
      </Box>
    </ProjectProvider>
  );
}
